import * as React from 'react';
import { Timetable } from 'timetable-model';
import {
  IsAllowed,
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useInstitutionFilter } from 'cb-front-end';

export const TimetableSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        { fieldId: 'institution_id', operator: 'eq', value: '', display: 'hidden' },
        { fieldId: 'title', operator: 'ct', value: '' },
      ],
    },
  });
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(Timetable, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(Timetable, queryOptions);

  return (
    <>
      <PageTitle verb="Search" entity={Timetable} />
      <Section>
        <IsAllowed entity={Timetable} action="create">
          <Link to="/admin/timetable/create">
            <Button size="sm" variant="primary">
              Create a new Timetable
            </Button>
          </Link>
          <div className="mb20px" />
        </IsAllowed>
        <PaginatorAndListSettings
          entity={Timetable}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
